import { themeStyle } from "../../components/Components";
import React, { useEffect, useState, useRef, Fragment } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Link, Navigate, useNavigate } from "react-router-dom";
import { DatePicker } from "@mui/x-date-pickers";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { LocalizationProvider } from "@mui/x-date-pickers";
import Card from "@mui/material/Card";
import CardActionArea from "@mui/material/CardActionArea";
import CardActions from "@mui/material/CardActions";
import CardContent from "@mui/material/CardContent";
import CardMedia from "@mui/material/CardMedia";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import Grid from "@mui/material/Grid";
import Sidebar from "../../components/Sidebar";
import PropTypes from "prop-types";
import LinearProgress from "@mui/material/LinearProgress";
import Box from "@mui/material/Box";
import { API_URL, MAIN_TITLE, alertMessage } from "../../actions/auth";
import Paper from "@mui/material/Paper";
import Fab from "@mui/material/Fab";
import CheckIcon from "@mui/icons-material/Check";
import CloseIcon from "@mui/icons-material/Close";
import TextField from "@mui/material/TextField";
import PublishIcon from "@mui/icons-material/Publish";
import Avatar from "@mui/material/Avatar";
import axios from "axios";
import CircularProgress from "@mui/material/CircularProgress";
import AttachFileIcon from "@mui/icons-material/AttachFile";
import PriorityHighIcon from "@mui/icons-material/PriorityHigh";
import Drawer from "@mui/material/Drawer";
import AddBoxIcon from "@mui/icons-material/AddBox";
import Checkbox from "@mui/material/Checkbox";
import moment from "moment";
import DeleteIcon from "@mui/icons-material/Delete";
import ButtonBase from "@mui/material/ButtonBase";
import Modal from "@mui/material/Modal";
import Backdrop from "@mui/material/Backdrop";
import Fade from "@mui/material/Fade";
import IconButton from "@mui/material/IconButton";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";
function makeid(length) {
  var result = "";
  var characters =
    "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
  var charactersLength = characters.length;
  for (var i = 0; i < length; i++) {
    result += characters.charAt(Math.floor(Math.random() * charactersLength));
  }
  return result;
}

function Journeys() {
  const dispatch = useDispatch();
  const state = useSelector((state) => state);
  const [journeys, setJourneys] = useState([]);
  const [dateList, setDateList] = useState([]);
  const [selectedDate, setSelectedDate] = useState("");

  const [isLoading, setIsLoading] = useState(true);
  const navigate = useNavigate();
  const [month, setMonth] = useState(1);
  const [year, setYear] = useState("2025");

  const [open2, setOpen2] = useState(false);

  function createAlert(type, title, message) {
    dispatch(alertMessage(type, title, message));
  }

  if (state.auth.refresh == "REFRESH_DATA") {
    getData();
    dispatch({ type: "REFRESH_DATA", payload: null });
  }

  useEffect(() => {
    if (state.auth.isLoading) {
      dispatch({ type: "ENTRY_PAGE", payload: window.location.pathname });
      navigate("/", { replace: true });
    } else {
      getData();
    }
  }, []);

  const [isSubmitting, setIsSubmitting] = useState(false);

  function getDateList() {
    var dates = Object.keys(dateList).map((dat, index) => (
      <MenuItem value={dat}>{dat}</MenuItem>
    ));
    return dates;
  }

  function getData() {
    var body = {};
    const config = {
      headers: {
        Authorization: state.auth.token,
        "Content-Type": "application/json",
      },
    };

    body["institution_id"] = state.auth.user.institution_id;
    body["user_id"] = state.auth.user.user_id;
    body = JSON.stringify(body);

    axios
      .post(API_URL + "/get_journeys", body, config)
      .then((res) => {
        setJourneys(res.data);
        setSelectedDate(Object.keys(res.data)[0]);
        setDateList(Object.keys(res.data));
        setIsLoading(false);
      })
      .catch((err) => {
        createAlert("ERROR", "Error", "An error occured.");
      });
  }

  function getContent() {
    if (journeys[selectedDate].length == 0) {
      return (
        <div
          style={{
            marginTop: "200px",
            height: "100px",
            width: "100%",
            display: "flex",
            justifyContent: "center",
          }}
        >
          <div style={{ textAlign: "center" }}>
            <Fab
              size="large"
              style={{
                border: "3px solid #aaa",
                boxShadow: "none",
                backgroundColor: "transparent",
              }}
              aria-label="add"
            >
              <PriorityHighIcon
                style={{
                  color: "grey",
                }}
              />
            </Fab>
            <br />
            <h4 style={{ color: "grey" }}>No journeys have been added yet.</h4>
          </div>
        </div>
      );
    } else {
      return (
        <div style={{ width: "100vw", fontSize: "18px" }}>
          <h2>All Journeys for {selectedDate}</h2>
          <Grid
            container
            style={{
              paddingBottom: "5px",
              marginBottom: "5px",
              borderBottom: "1px solid #aaa",
            }}
          >
            <Grid item md={1}>
              Sr.
            </Grid>
            <Grid item md={2}>
              Route ID
            </Grid>
            <Grid item md={2}>
              Bus Number
            </Grid>
            <Grid item md={3}>
              Assigned Area
            </Grid>
            <Grid item md={3}>
              Primary Driver Name
            </Grid>
            <Grid
              item
              md={1}
              style={{ display: "flex", justifyContent: "center" }}
            >
              Delete
            </Grid>
          </Grid>
          {journeys[selectedDate].map((item, index) => (
            <Grid container style={{ marginTop: "15px" }}>
              <Grid item md={1}>
                {index + 1}
              </Grid>
              <Grid item md={2}>
                {item.journey_id}
              </Grid>

              <Grid item md={2}>
                {item.bus_number}
              </Grid>
              <Grid item md={3}>
                {item.area}
              </Grid>
              <Grid item md={3}>
                {item.primary_driver}
              </Grid>
              <Grid
                item
                md={1}
                style={{ display: "flex", justifyContent: "center" }}
              >
                <ButtonBase
                  style={{
                    cursor: "pointer",
                    display: "flex",
                    backgroundColor: "#ff3333",
                    padding: "5px",
                    alignItems: "center",
                    justifyContent: "center",
                    borderRadius: "6px",
                  }}
                  onClick={() => {
                    // setSelectedRoute(item);
                    setOpen2(true);
                  }}
                >
                  <DeleteIcon style={{ color: "white", fontSize: "18px" }} />
                </ButtonBase>
              </Grid>
            </Grid>
          ))}
        </div>
      );
    }
  }

  if (!state.auth.isLoading) {
    if (state.auth.isAuthenticated) {
      if (state.auth.user.is_transport) {
        if (isLoading) {
          return (
            <div
              style={{
                width: "100%",
                height: "100%",
                display: "flex",
                justifyContent: "center",
                backgroundColor: "white",
                marginTop: "46vh",
              }}
            >
              <CircularProgress />
            </div>
          );
        }
        return (
          <Fragment>
            <Modal
              aria-labelledby="transition-modal-title"
              aria-describedby="transition-modal-description"
              open={open2}
              onClose={() => setOpen2(false)}
              closeAfterTransition
              BackdropComponent={Backdrop}
              BackdropProps={{
                timeout: 500,
              }}
            >
              <Fade in={open2}>
                <div
                  style={{
                    position: "absolute",
                    top: "50%",
                    backgroundColor: "white",
                    left: "50%",
                    transform: "translate(-50%, -50%)",
                    width: 400,
                    padding: "20px",
                  }}
                >
                  <div style={{ marginTop: "-25px" }}>
                    <div
                      style={{
                        marginTop: "20px",
                        display: "flex",
                        justifyContent: "space-between",
                      }}
                    >
                      <h3>Journey Information</h3>
                      <IconButton size="small">
                        <CloseIcon
                          onClick={() => setOpen2(false)}
                          style={{ color: themeStyle.primaryColor }}
                        />
                      </IconButton>
                    </div>

                    <br></br>
                    <br></br>
                    <div
                      style={{
                        display: "flex",
                        width: "100%",
                        justifyContent: "flex-end",
                      }}
                    >
                      <Button
                        style={{ height: "30px", marginLeft: "10px" }}
                        variant="contained"
                        onClick={() => setOpen2(false)}
                      >
                        OK
                      </Button>
                    </div>
                  </div>
                </div>
              </Fade>
            </Modal>
            <Sidebar
              tabs={
                <Grid container spacing={1.5} justifyContent="flex-end">
                  {/* <Grid item md={2}>
                    <Select
                      value={year}
                      // onChange={(e) => handleApprovalChange(e.target.value)}
                      style={{
                        marginTop: "2px",
                        height: "40px",
                        marginBottom: "5px",
                      }}
                      fullWidth
                      variant={"outlined"}
                    >
                      <MenuItem value={"2025"}>2025</MenuItem>
                    </Select>
                  </Grid>{" "}
                  <Grid item md={2}>
                    <Select
                      value={month}
                      onChange={(e) => setMonth(e.target.value)}
                      variant={"outlined"}
                      fullWidth
                      style={{
                        marginTop: "2px",
                        height: "40px",
                        marginBottom: "5px",
                      }}
                    >
                      <MenuItem value={1}>January</MenuItem>
                      <MenuItem value={2}>February</MenuItem>
                      <MenuItem value={3}>March</MenuItem>
                      <MenuItem value={4}>April</MenuItem>
                      <MenuItem value={5}>May</MenuItem>
                      <MenuItem value={6}>June</MenuItem>
                      <MenuItem value={7}>July</MenuItem>
                      <MenuItem value={8}>August</MenuItem>
                      <MenuItem value={9}>September</MenuItem>
                      <MenuItem value={10}>October</MenuItem>
                      <MenuItem value={11}>November</MenuItem>
                      <MenuItem value={12}>December</MenuItem>
                    </Select>
                  </Grid> */}
                  <Grid item md={2}>
                    <Select
                      value={selectedDate}
                      onChange={(e) => setSelectedDate(e.target.value)}
                      variant={"outlined"}
                      fullWidth
                      style={{
                        marginTop: "2px",
                        height: "40px",
                        marginBottom: "5px",
                      }}
                    >
                      {getDateList()}
                    </Select>
                  </Grid>
                </Grid>
              }
            />
            <div
              style={{
                margin: "38px 40px 20px 90px",
                backgroundColor: "white",
                display: "flex",
              }}
            >
              {getContent()}
            </div>
          </Fragment>
        );
      } else {
        createAlert("ERROR", "Permission Denied.", "Please Login as Student");
        dispatch({
          type: "AUTH_ERROR",
        });
        dispatch({ type: "AUTH_ERROR" });
      }
    } else {
      dispatch({ type: "AUTH_ERROR" });
    }
  } else {
    return (
      <div
        style={{
          width: "100%",
          height: "100%",
          display: "flex",
          justifyContent: "center",
          backgroundColor: "white",
          marginTop: "46vh",
        }}
      >
        <CircularProgress />
      </div>
    );
  }
}

export default Journeys;
